import React, { memo, useState, useEffect, useMemo, useCallback } from 'react';
import { Table, TableProps, Radio } from 'tea-component';
import { SortBy } from 'tea-component/lib/table/addons';
import { getColumns } from './utils/common';
import { getNumberOfDotUnit } from '@gp/utils/common';
import { TABLE_SORT_KEY, TABLE_SUB_KEY, TABLE_COMMON_COL_HEADER_MAP } from './utils/constants';
import classNames from 'classnames';

import TriggerFoldBtn from '@gp/components/TriggerFoldBtn';
import './index.scss';

const { autotip, sortable, injectable, pageable, scrollable } = Table.addons;
const PLATFORM = ['mobile', 'pc', 'console'];

interface BreakdownTablePropsType {
  // className?: string;
  // style?: React.CSSProperties;
  loading: boolean;
  isHideExpandButton: boolean;
  data: any;
  toGameDetail: any;
  isNeedData: boolean;
  triggerFoldExpand: boolean;
  setSorts: React.Dispatch<React.SetStateAction<SortBy<any>>> | null;
  // setTableIsNoData: React.Dispatch<React.SetStateAction<boolean>> | null;
  dataSegment: 'filter' | 'all';
}

const DEFAULT_PROPS: BreakdownTablePropsType = {
  loading: true,
  isHideExpandButton: true,
  data: null,
  setSorts: null,
  triggerFoldExpand: false,
  // setTableIsNoData: null,
  dataSegment: 'filter',
};

function BreakdownTable(props: BreakdownTablePropsType) {
  const {
    loading: propsLoading,
    isHideExpandButton,
    data,
    triggerFoldExpand,
    setSorts: setPropsSorts,
    // setTableIsNoData,
    dataSegment,
    toGameDetail,
    isNeedData = false,
  } = props;

  // 表格是否出现滚动条
  const [tableIsScroll, setTableIsScroll] = useState<boolean>(false);
  // const [tableBodyMaxH, setTableBodyMaxH] = useState<number>(500);
  const [isClickSort, setIsClickSort] = useState<boolean>(false);
  // 是否展开隐藏列
  const [sorts, setSorts] = useState<SortBy<any>>({
    by: 'total_revenue',
    order: 'desc',
  });
  const [paginationMsg, setPaginationMsg] = useState<{
    pageIndex: number;
    pageSize: number;
    total: number;
  }>({ pageIndex: 1, pageSize: 10, total: 0 });
  const [records, setRecords] = useState<any>([]);
  // 展开的group列
  const [unFoldList, setUnFoldList] = useState<string[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  // const [dataSegment, setDataSegment] = useState<'filter' | 'all'>('filter');

  // 虚假的loading，目的是为了让横纵滚动条回到初始位置
  const resetScroll = useCallback(() => {
    setLoading(true);
    const t = setTimeout(() => {
      clearTimeout(t);
      setLoading(false);
    }, 50);
  }, []);
  // 判断横向是否出现滚动条（由于border样式影响，当不需要横向滚动条的时候也出现了）
  // const handleResize = useCallback(() => {
  //   const tableBody = document.querySelector(
  //     '.dbg-breakdown-list-table .tea-table__body',
  //   );
  //   // @ts-ignore
  //   const flag = tableBody?.offsetWidth < tableBody?.firstChild?.offsetWidth;
  //   // @ts-ignore
  //   tableBody.style.overflowX = flag ? 'overlay' : 'hidden';
  // }, []);

  /* useEffect(() => {
    setLoading(propsLoading);
  }, [propsLoading]);
 */
  // 判断横向是否出现滚动条（由于border样式影响，当不需要横向滚动条的时候也出现了）
  // useEffect(() => {
  //   if (propsLoading) return;
  //   // handleResize();
  // }, [unFoldList?.length, propsLoading]);
  // useEffect(() => {
  //   window.addEventListener('resize', handleResize);

  //   return () => {
  //     window.removeEventListener('resize', handleResize);
  //   };
  // }, []);

  // 初始化整理数据
  const orgRecords = useMemo(() => {
    const _dataList = data?.list || [];
    const dataList =
      dataSegment === 'filter'
        ? _dataList?.filter((item: any) => {
            // 过滤掉YTM Total Revenue为0或无数据的数据
            if (!item?.ytm_total_revenue || item?.ytm_total_revenue === '0') return false;
            return true;
          }) || []
        : _dataList;
    const newRecords =
      dataList
        ?.map((item: any, index: number) => {
          const newKeyItem: { [keyName: string]: string } = {}; // 新增字段集，把_info里面的内容提到外面
          for (let i = 0; i < TABLE_COMMON_COL_HEADER_MAP?.length; i++) {
            const t: CommonColHeaderItemType = TABLE_COMMON_COL_HEADER_MAP?.[i];
            if (t?.groupKey && PLATFORM?.includes(t?.platform)) {
              newKeyItem[t?.keyName] = '';
              newKeyItem[`${t?.keyName}_ratio`] = '';
              const info = item?.[`${t?.groupKey}_info`];
              if (Array.isArray(info) && info?.length) {
                for (let ii = 0; ii < info?.length; ii++) {
                  const it = info?.[ii];
                  if (it?.entity_type === t?.platform) {
                    newKeyItem[t?.keyName] = it?.value;
                    newKeyItem[`${t?.keyName}_ratio`] = it?.ratio;
                  }
                }
              }
            }
          }

          return {
            uniqueId: `${item?.game_id}_${index}`,
            ...item,
            ...newKeyItem,
          };
        })
        ?.filter((item: any) => item?.game_name !== 'All Games') || [];
    setPaginationMsg(Object.assign(paginationMsg, { total: newRecords?.length || 0 }));

    return newRecords;
  }, [propsLoading, dataSegment, data]);

  /* // 前端排序
  useEffect(() => {
    if (!Array.isArray(orgRecords) || !orgRecords?.length) {
      setRecords([]);
      return;
    }
    let allGamesItem = {};
    // All Games项不参与排序
    const sortItems = orgRecords?.filter((t: any) => {
      const isAllGamesItem = ['All Games', 'All Games']?.includes(t?.game_name);
      if (isAllGamesItem) {
        allGamesItem = t;
        return false;
      }
      return true;
    });
    const sortRecords = getArraySort(
      sortItems,
      sorts?.order || 'desc',
      sorts?.by === 'projects' ? 'string' : 'number',
      sorts?.by === 'projects' ? 'game_name' : sorts?.by || 'total_revenue',
      true,
      'string',
      'game_name',
    );
    setRecords([allGamesItem, ...sortRecords]);
  }, [sorts?.by, sorts?.order, orgRecords]); */
  useEffect(() => {
    if (!Array.isArray(orgRecords) || !orgRecords?.length) {
      setRecords([]);
      return;
    }
    setRecords([...orgRecords]);
  }, [orgRecords]);

  const pageSizeOptions = [10, 20, 50, 100];
  const showPageableOperation = paginationMsg?.total > Math.min(...pageSizeOptions);
  const addons = [
    injectable({
      cell: (props, context) => ({
        className: TABLE_SUB_KEY.includes(context.column.key)
          ? triggerFoldExpand
            ? 'table-expand-col show'
            : 'table-expand-col hide'
          : '',
      }),
    }),
    pageable({
      stateTextVisible: true,
      pageSizeVisible: showPageableOperation,
      pageIndexVisible: showPageableOperation,
      jumpVisible: showPageableOperation,
      endJumpVisible: showPageableOperation,
      pageIndex: paginationMsg?.pageIndex,
      pageSize: paginationMsg?.pageSize,
      pageSizeOptions: [10, 20, 50, 100],
      recordCount: paginationMsg?.total,
      stateText: `${getNumberOfDotUnit(paginationMsg?.total)} item${
        paginationMsg?.total > 1 ? 's' : ''
      } in total`,
      onPagingChange: ({ pageIndex, pageSize }) => {
        setPaginationMsg({
          ...paginationMsg,
          pageIndex: pageIndex as number,
          pageSize: pageSize as number,
        });
        resetScroll();
      },
    }),
    sortable({
      columns: TABLE_SORT_KEY,
      value: sorts ? [sorts] : [],
      onChange: (value) => {
        setIsClickSort(true);
        setSorts(value?.[0]);
        setPropsSorts?.(value?.[0]);
        setPaginationMsg({ ...paginationMsg, pageIndex: 1 });
        // resetScroll();
      },
    }),
    scrollable({
      // maxHeight: 500,
      // minHeight: 200,
    }),
    autotip({
      isLoading: propsLoading || loading,
      hideIcon: !(propsLoading || loading), // loading状态显示图标，其他情况不显示
      emptyText: 'The list has no data yet.',
      style: {
        height: 172,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        boxSizing: 'border-box',
      },
    }),
  ];

  // 这里因为产品要求默认展示10条，且一定出现滚动条，所以特殊处理，与系统其它地方产生差异
  // if (paginationMsg?.total <= 20) addons.shift();

  // 判断滚动条是否显示，表头样式更改
  useEffect(() => {
    if (propsLoading) return;
    setTimeout(() => {
      const tableBody = document.querySelector('.dbg-breakdown-list-table .tea-table__body');
      // @ts-ignore
      const flag = tableBody?.clientHeight < tableBody?.firstChild?.clientHeight;
      setTableIsScroll(flag);
    });
  }, [paginationMsg.total, paginationMsg.pageSize, paginationMsg.pageIndex, propsLoading, loading]);

  // loading发生改变页码重置为1
  useEffect(() => {
    setPaginationMsg({ ...paginationMsg, pageIndex: 1 });
  }, [dataSegment, propsLoading]);

  /* useEffect(() => {
    setPaginationMsg({...paginationMsg, pageIndex: 1});
  }, [dataSegment]); */

  // 表格无数据隐藏下载按钮
  /* useEffect(() => {
    setTableIsNoData?.(!Array.isArray(records) || !records?.length || propsLoading || loading);
  }, [records, loading, propsLoading]); */

  return (
    <>
      <Table
        // verticalTop
        className={classNames({
          'dbg-common-table dbg-breakdown-list-table dbg-table-sticky dbh-action-state-center-table':
            true,
          'scroll-table-header': tableIsScroll,
          'first-item-h': paginationMsg?.pageIndex < 2,
          'dbg-breakdown-table-expand-col': triggerFoldExpand,
        })}
        bordered="all"
        records={loading || propsLoading ? [] : records}
        recordKey="uniqueId"
        columns={
          getColumns(
            isHideExpandButton,
            unFoldList,
            setUnFoldList,
            paginationMsg?.total,
            data?.header_date,
            triggerFoldExpand,
            toGameDetail,
            isNeedData,
          ) as TableProps['columns']
        }
        addons={addons}
      />
    </>
  );
}

BreakdownTable.defaultProps = DEFAULT_PROPS;

export default memo(BreakdownTable);
